import { Controller } from "stimulus"
import Popper from 'popper.js'

export default class extends Controller {
  static targets = ["spinner", "searchIcon", "popper", 'anchor', 'overlay', 'input']

  connect() {
    this.handleBeforeCache = this.close.bind(this)
    document.addEventListener('turbolinks:before-cache', this.handleBeforeCache)
  }

  disconnect() {
    document.removeEventListener('turbolinks:before-cache', this.handleBeforeCache)
    this.destroyPopper()
  }

  showSpinner() {
    this.spinnerTarget.classList.remove('d-none');
    this.searchIconTarget.classList.add('d-none');
  }

  showResults() {
    // Mostrar primero: Popper necesita medir el panel visible
    this.popperTarget.classList.remove('d-none');
    this.overlayTarget.classList.remove('d-none');

    if (this.popper) {
      this.popper.scheduleUpdate();
    } else {
      this.popper = new Popper(this.anchorTarget, this.popperTarget, {
        placement: 'bottom',
        modifiers: {
          offset: { offset: '0, 6' },
          preventOverflow: { boundariesElement: 'viewport', padding: 12 },
          flip: { enabled: false }
        }
      });
    }
  }

  hideSpinner() {
    this.spinnerTarget.classList.add('d-none');
    this.searchIconTarget.classList.remove('d-none');
  }

  close() {
    this.overlayTarget.classList.add('d-none');
    this.popperTarget.classList.add('d-none');
    this.inputTarget.value = "";
    this.destroyPopper();
  }

  destroyPopper() {
    if (this.popper) {
      this.popper.destroy();
      this.popper = null;
    }
  }

  fillForm(event) {
    var productCode = event.currentTarget.dataset.code;
    var productId = event.currentTarget.dataset.id;
    document.getElementById('fill-code').value = productCode;
    document.getElementById('fill-id').value = productId;
    this.close();
  }
}
